// extracted by mini-css-extract-plugin
export var copyableField = "_nd-4";
export var customerBadge = "_nd-0";
export var customerInfoTitle = "_nd-2";
export var details = "_nd-1";
export var dropdownContainer = "_nd-5";
export var dropdownImage = "_nd-6";
export var editAssigneeForm = "_nd-a";
export var editButton = "_nd-3";
export var email = "_nd-7";
export var hidden = "_nd-d";
export var input = "_nd-8";
export var saveButton = "_nd-b";
export var shopifyIcon = "_nd-c";
export var suggestionBadge = "_nd-e";
export var suggestionText = "_nd-f";
export var username = "_nd-9";